export enum SubtitleType {
  Full = "Full",
  FullWithoutPartial = "FullWithoutPartial",
  Partial = "Partial",
}
